export default {"src":"/_next/static/media/ra-aircraft-vali.60e349ea.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};